import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';

import { InputNumber } from 'primereact/inputnumber';

import { InputText } from "primereact/inputtext";
import { Dropdown } from 'primereact/dropdown';
import { showToast } from "../ToastManager";

import AgendamentoTipoService from "../../service/AgendamentoTipoService";
import EmpresaService from "../../service/EmpresaService";
import RoleService from '../../service/RoleService';

const agendamentoTipoService = new AgendamentoTipoService();
const empresaService = new EmpresaService();

const CadastrarTipoAgendamento = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let tipoAgendamentoNovo = {
        companies: null,
        company_id: null,
        nome: '',
        descricao: '',
        duracao_padrao: '',
        valor: '',
    };

    const [tipoAgendamento, setTipoAgendamento] = useState(tipoAgendamentoNovo);
    const [company, setCompany] = useState();
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { id } = useParams();

    const initEmpresa = useCallback(async () => {
        setLoading(true);

        try {
            const data = await empresaService.listAllEmpresas(iss);
            const updatedItems = data.data.rows.map(({ categoria_id, categoriaCompany, cnpj, razaoSocial, telefone, endereco, cidade, estado, cep, excluido, ativo, url, createdAt, updatedAt, ...rest }) => rest);
            setCompany(updatedItems);
            if (data.data.count === 1) {
                setSelectedCompany(updatedItems[0])
                tipoAgendamento.company_id = updatedItems[0].id
                setTipoAgendamento(tipoAgendamento);
            }
        } catch (error) {
            console.error("Erro ao carregar empresas:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar empresas' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    useEffect(() => {
        initEmpresa();
    }, [initEmpresa]);

    useEffect(() => {
        const loadAgendaData = async () => {
            if (id && !dataLoaded) {
                try {
                    setLoading(true);
                    const data = await agendamentoTipoService.getTipoAgendamento(iss, id);
                    const tipoAgendamentoNovo = data.data.rows[0];

                    const company = {
                        id: tipoAgendamentoNovo.companies.id,
                        name: tipoAgendamentoNovo.companies.name,
                    };
                    setSelectedCompany(company)
                    setTimeout(() => {
                        setTipoAgendamento(tipoAgendamentoNovo);
                    }, 200);
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        }
        loadAgendaData();
    }, [dataLoaded, id, iss]);

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        let _tipoAgendamento = { ...tipoAgendamento };

        if (checkbox) {
            val = e.checked;
        }

        if (name === 'company_id') {
            setSelectedCompany(e.value)
            val = e.value.id;
        }

        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_tipoAgendamento[parent]) {
                _tipoAgendamento[parent] = {}; // Cria o objeto pai se não existir
            }
            _tipoAgendamento[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _tipoAgendamento[name] = val;
            } else {
                _tipoAgendamento[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }
        setTipoAgendamento(_tipoAgendamento);
    }

    const cadastrar = () => {
        setSubmitted(true);
        if (tipoAgendamento.nome && tipoAgendamento.company_id && tipoAgendamento.duracao_padrao && tipoAgendamento.valor && tipoAgendamento.descricao) {
            setLoading(true)

            if (tipoAgendamento.id != null) {
                agendamentoTipoService.putTipoAgendamento(iss, tipoAgendamento, tipoAgendamento.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de tipo do agendamento', detail: 'Tipo do agendamento editada com sucesso' });
                    history.push('/agendamento/tipo/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar tipoAgendamento' });
                }).finally(() => { setLoading(false) });
            } else {
                agendamentoTipoService.postTipoAgendamento(iss, tipoAgendamento).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de tipo do agendamento', detail: 'Tipo do agendamento cadastrada com sucesso' });
                    history.push('/agendamento/tipo/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }


        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }

    }

    return (
        <div className="grid">
            <h4>Informações do Serviço</h4>
            <div className="col-12">
                <div className="card">
                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-3">
                            <span className="p-float-label">
                                <Dropdown optionLabel="name" value={selectedCompany}
                                    className={classNames({ 'p-invalid': submitted && !tipoAgendamento.company_id })}
                                    options={company}
                                    disabled={!RoleService.isAdmin()}
                                    onChange={(e) => {
                                        onInputChange(e, 'company_id')
                                    }} />
                                <label htmlFor="company_id">Empresa</label>
                            </span>
                            {submitted && !selectedCompany &&
                                <small className="p-invalid">Empresa é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-3">
                            <span className="p-float-label">
                                <InputText value={tipoAgendamento.nome} onChange={(e) => onInputChange(e, 'nome')}
                                    className={classNames({ 'p-invalid': submitted && !tipoAgendamento.nome })} required id="nome" type="text" />
                                <label htmlFor="nome">Nome do serviço</label>
                            </span>
                            {submitted && !tipoAgendamento.nome && <small className="p-invalid">Nome do serviço é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-3">
                            <span className="p-float-label">
                                <InputText value={tipoAgendamento.duracao_padrao} onChange={(e) => onInputChange(e, 'duracao_padrao')}
                                    className={classNames({ 'p-invalid': submitted && !tipoAgendamento.duracao_padrao })} required id="duracao_padrao" type="text" />
                                <label htmlFor="duracao_padrao">Duração do atentimento (em minutos)</label>
                            </span>
                            {submitted && !tipoAgendamento.duracao_padrao && <small className="p-invalid">Duração é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-3">
                            <span className="p-float-label">
                                <InputNumber value={tipoAgendamento.valor} onValueChange={(e) => onInputChange(e, 'valor')} minFractionDigits={2} maxFractionDigits={5} className={classNames({ 'p-invalid': submitted && !tipoAgendamento.duracao_padrao })} required id="valor" />
                            </span>
                            {submitted && !tipoAgendamento.valor && <small className="p-invalid">valor é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12">
                            <span className="p-float-label">
                                <InputText value={tipoAgendamento.descricao} onChange={(e) => onInputChange(e, 'descricao')}
                                    className={classNames({ 'p-invalid': submitted && !tipoAgendamento.descricao })} required id="descricao" type="text" />
                                <label htmlFor="descricao">Descrição</label>
                            </span>
                            {submitted && !tipoAgendamento.descricao && <small className="p-invalid">Descrição é obrigatório.</small>}
                        </div>
                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarTipoAgendamento, comparisonFn);
